import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setQuestions = questions => {
	return {
		type: ActionTypes.LOAD_QUESTIONS,
		questions: questions.data
	};
};

export const setTopQuestions = questions => {
	return {
		type: ActionTypes.LOAD_TOPQUESTIONS,
		questions: questions
	};
};



export const setLevels = levels => {
	return {
		type: ActionTypes.LOAD_LEVELS,
		levels: levels.data
	};
};


export const setLevelCategories = levelCategories => {
	return {
		type: ActionTypes.LOAD_LEVELCATEGORIES,
		levelCategories: levelCategories.data
	};
};
/*
export const onUpdateInformativeText = response => {
	return {
		type: ActionTypes.MODIFY_INFORMATIVETEXT,
		response: response
	};
};
*/

export const loadQuestions = () => {
	return dispatch => {
		axios
			.get("http://getupstudio.co/sanofiapi/questions-soliqua/list")
			.then(response => {
				dispatch(setQuestions(response.data));
			})
			.catch(error => {});
	};
};

export const loadTopQuestions = () => {
	return dispatch => {
		axios
			.get("http://getupstudio.co/sanofiapi/questions-soliqua/top")
			.then(response => {
				dispatch(setTopQuestions(response.data));
			})
			.catch(error => {});
	};
};



export const loadLevels = (idcategory) => {
	return dispatch => {
		axios
			.get("http://190.105.227.203/sanofiapi/questions-soliqua/levels/"+idcategory)
			.then(response => {
				dispatch(setLevels(response.data));
			})
			.catch(error => {});
	};
};


export const loadLevelCategories = (idlevel) => {
	return dispatch => {
		axios
			.get("http://190.105.227.203/sanofiapi/questions-soliqua/levelcategories/"+idlevel)
			.then(response => {
				dispatch(setLevelCategories(response.data));
			})
			.catch(error => {});
	};
};


export const saveQuestion = (question/*, token*/) => {
	return dispatch => {
		//const AuthStr = "Bearer ".concat(token);
		axios
			.post(
				"http://getupstudio.co/sanofiapi/questions-soliqua/",
                question
                /*,
				{
					headers: { Authorization: AuthStr }
				}*/
			)
			.then(response => {
				dispatch(loadQuestions());
			})
			.catch(error => {});
	};
};



export const updateQuestion = (question/*, token*/) => {
	return dispatch => {
		//const AuthStr = "Bearer ".concat(token);
		axios
			.patch(
				"http://getupstudio.co/sanofiapi/questions-soliqua/",
                question
                /*,
				{
					headers: { Authorization: AuthStr }
				}*/
			)
			.then(response => {
				dispatch(loadQuestions());
			})
			.catch(error => {});
	};
};



export const updateQuestionConnect = (question/*, token*/) => {
	return dispatch => {
		//const AuthStr = "Bearer ".concat(token);
		axios
			.post(
				"http://getupstudio.co/sanofiapi/questions-soliqua/updateconnect",
                question
                /*,
				{
					headers: { Authorization: AuthStr }
				}*/
			)
			.then(response => {
				dispatch(loadQuestions());
			})
			.catch(error => {});
	};
};



export const saveQuestionConnect = (question/*, token*/) => {
	return dispatch => {
		//const AuthStr = "Bearer ".concat(token);
		axios
			.post(
				"http://getupstudio.co/sanofiapi/questions-soliqua/connect",
                question
                /*,
				{
					headers: { Authorization: AuthStr }
				}*/
			)
			.then(response => {
				dispatch(loadQuestions());
			})
			.catch(error => {});
	};
};



export const deleteQuestion = idquestion => {
	return dispatch => {
		axios
			.delete("http://getupstudio.co/sanofiapi/questions-soliqua/", {
				params: { id: String(idquestion) }
			})
			.then(response => {
				dispatch(loadQuestions());
			})
			.catch(error => {});
	};
};
